import React, { useState } from "react";
import { Button, Input, Spinner } from "reactstrap";

import ValidationGroup from "~/components/validation";
import Cashouts        from "~/services/cashouts";


const CashoutsModal = ({selectedType, setMessage, setOverlayOpen})=> {

  const [account , setAccount] = useState("");
  const [loading , setLoading] = useState(false);
  const [errors  , setErrors]  = useState({});

  const validation = ValidationGroup("Cashout");

  const hasErrors = ()=> {

    const errorList = {
      ...validation("account", account, { selectedType })
    };
    setErrors(errorList);

    return Boolean(Object.values(errorList).length);
  };

  const submit = async (e)=> {

    e.stopPropagation();
    if(hasErrors()) return;
    setLoading(true);

    Cashouts.create({type: selectedType.id, account: account})
      .then((msg)=> {
        setMessage(msg);
        setOverlayOpen({completed: true});
      })
      .catch(setErrors)
      .finally(()=> setLoading(false));
  };

  return (
    <div className="cashout-form">

      { selectedType.limit && (<p className="text-center m-0"> You can redeem this reward { selectedType.limit } { selectedType.limit > 1 ? 'times' : 'time'}  only! </p>) }

      <div className=" info">
        <img src={selectedType.currencyIcon} />
        <p> You will get <strong>{selectedType.amount}$ </strong> in {selectedType.currencyName} for <strong> {selectedType.points} </strong> points. </p>
      </div>

      <hr />

      <div>
        <Input type="text"
          value={account}
          className={`${errors.account || errors.generalError ? 'is-invalid' : ''}`}
          required={true}
          onClick={(e)=> e.stopPropagation()}
          disabled={loading}
          placeholder={`${selectedType.currencyName} Account`}
          onChange={(e)=> setAccount(e.target.value)}
        />

        { errors.account      && <p className="text-danger"> { errors.account } </p> }
        { errors.generalError && <p className="text-danger"> { errors.generalError } </p> }

        <Button color="primary" className="btn-block btn action m-t-10" onClick={submit} disabled={loading}>
          { loading ? <Spinner size="sm" /> : "Request Reward" }
        </Button>

        { selectedType.info && <p className="m-t-20 text-muted text-center"> { selectedType.info } </p> }

      </div>
    </div>
  );
};

export default CashoutsModal;
